import type { IActivityWireItem } from '@platform/dao';
import { displayNumber } from '../../shell/displayNumber';

const CHANGES = new Set(['changed', 'status_changed', 'assigned']);
/** Довжина уривка коментаря (прототип v4 auditText: slice(0, 90)). */
const EXCERPT = 90;

/**
 * Текст зміни для журналу аудиту й «Нещодавніх змін» (прототип v4 auditText): створення — «Створено»; зміна поля — «Поле: було → стало»
 * (значення для показу, порожнє — «—»; без значень — «Поле: змінено»); коментар — «Коментар: текст» (перші 90 символів; без тексту —
 * «Прокоментовано»); доручення — «Доручення: роль»; зв'язок — «пов’язано з 9» / «зв’язок з 9 вилучено» (голий номер); решта — текст сервера.
 */
export function auditText(item: IActivityWireItem, t: (key: string, vars?: Record<string, unknown>) => string): string {
  if (item.kind === 'created') return t('sysAdmin.audit.created');
  if (item.kind === 'comment') {
    const text = (item.toDisplay ?? item.to ?? '').trim();
    return text ? t('sysAdmin.audit.comment', { text: text.slice(0, EXCERPT) }) : t('sysAdmin.audit.commented');
  }
  if (item.kind === 'assigned' && item.field === 'assignment') return t('sysAdmin.audit.assignment', { role: item.toDisplay ?? '' });
  if ((item.kind === 'linked' || item.kind === 'unlinked') && item.otherDisplay) return t(`sysAdmin.audit.${item.kind}`, { other: displayNumber(item.otherDisplay) });
  if (CHANGES.has(item.kind) && item.field !== 'assignment') {
    const field = item.fieldLabel || item.field || t('sysAdmin.audit.field');
    const from = item.fromDisplay ?? null;
    const to = item.toDisplay ?? null;
    if (from === null && to === null) return t('sysAdmin.audit.edited', { field });
    return t('sysAdmin.audit.changed', { field, from: from ?? '—', to: to ?? '—' });
  }
  return item.text;
}
